module.exports = __webpack_public_path__ + "img/prompt-builder.69c29afe.jpg";